import { ControlBarButton, ControlBarButtonStyles } from "@azure/communication-react";
import React from "react";
import { PeopleFilled } from "@fluentui/react-icons";

interface ControlBarButtonProps {
    checked: boolean;
    onClick: () => void;
    styles?: ControlBarButtonStyles;
}


export const ControlBarParticipantsButton = (props: ControlBarButtonProps): JSX.Element => {

    const { checked, onClick, styles } = props;

    const chatIconFilled = <PeopleFilled fontSize={24} />;

    return (
        <ControlBarButton
            onClick={onClick}
            toggle={true}
            checked={checked}
            styles={styles}
            onRenderOnIcon={() => chatIconFilled}
            onRenderOffIcon={() => chatIconFilled}
        />
    );
};
